import React, { useState, useCallback } from 'react'
import styled, { css } from 'styled-components'
import { Icon, InlineIcon } from '@iconify/react';
import timesSolid from '@iconify/icons-la/times-solid';
import plusSolid from '@iconify/icons-la/plus-solid';
import { Button } from './Button'
import { useSelector, useDispatch, batch } from 'react-redux';
import { editCustomer, saveCustomer, saveLogo } from '../../store/data-export/customersSlice'
import { editReportSchedule, saveReportSchedule, toggleActive } from '../../store/data-export/reportSchedulesSlice'
import { getHost } from '../../api/host'
import { debounce } from 'lodash'
import { Toggle } from './Toggle'

const StyledTextInput = styled.input`
  font-size: 16px;
  border: 0;
  padding: 5px 10px;
  margin: 0px auto;
  width: 90%;
  display: block;
  resize: none;
  color: #444;
  font-size: 15px;
  line-height: 22px;
  font-family: inherit;
  background: #fff;
  color: #555;
  
  &:disabled {
    background: #FFF;
    color: #555;
  }
  
  &:focus {
    // border-bottom: 1px solid #ddd;
  }
`;

const TextInput = ({ disabled=false, value, onChange }: { disabled?: boolean; value: string; onChange?: any }) => {
  return (
    <StyledTextInput disabled={disabled} type="text" onChange={onChange} value={value}/>
  )
}

const StyledTextAreaInput = styled.textarea`
  font-size: 16px;
  border: 0;
  padding: 5px 10px;
  margin: 0px auto;
  width: 90%;
  display: block;
  resize: none;
  color: #444;
  font-size: 15px;
  line-height: 22px;
  height: 100px;
  font-family: inherit;
  background: #fff;
  color: #555;
  
  &:hover {
    // border: 1px solid #ddd;
  }
  
  &:focus {
    // border: 1px solid #ddd;
  }
`;

const TextAreaInput = ({ disabled=false, value, onChange }: { disabled?: boolean; value: string; onChange?: any }) => {
  return (
    <StyledTextAreaInput disabled={disabled} rows={4} value={value} onChange={onChange}></StyledTextAreaInput>
  )
}

const Label = styled.div<{margin?: string}>`
  color: #333;
  text-align: left;
  margin: ${props => props.margin || '0 0 10px 0;'};
  font-size: 14px;
`;

const SettingsContainer = styled.div`
  position: relative;
  width: 240px;
  height: 605px;
  background: transaprent;
  border: 1px solid #ddd;
  margin: 5px 0 0 10px;
  padding: 5px 20px;
  
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0 0 0 0;
  }
`;

const ListHeading = styled.div`
  color: #333;
  padding: 10px 0px;
  text-align: center;
  font-size: 16;
  color: #333;
  // border-bottom: 1px solid #ddd;
`;

const Tick = styled(Icon)`
  color: #555;
  padding: 0 5px;
  line-height: 0;
  right: 5px;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%) rotate(0) !important;
  transform: translateY(-50%) rotate(0) !important;
`;

const Plus = styled(Icon)`
  color: #555;
  right: 10px;
  position: absolute;',
  line-height: 0;
  top: 50%;
  -ms-transform: translateY(-50%) rotate(0) !important;
  transform: translateY(-50%) rotate(0) !important;
`;

const Row = styled.div<{margin?: string}>`
  margin: ${props => props.margin || '10px auto 0 auto'};
`;

const InlineRow = styled.div<{margin?: string}>`
  margin: ${props => props.margin || '10px auto 0 auto'};
  display: flex;
  justify-content: space-between;
`;

const StyledRecipientsPopup = styled.div`
  position: absolute;
  display: none;
  border: 1px solid #ddd;
  padding: 10px;
`;

const StyledRecipient = styled.div`

`;

const RecipientsPopup = ({ recipients }: { recipients: any }) => {
  return (
    <StyledRecipientsPopup>
      {recipients.map((recipient, index) => (
        <StyledRecipient>
          {recipient.first_name} {recipient.last_name}
        </StyledRecipient>
      ))}
    </StyledRecipientsPopup>
  )
}

const StyledRecipients = styled.div`
  scrollbar-width: thin;
  height: 80px;
  overflow: hidden;
  font-size: 16px;
  border: 0;
  overflow-y: scroll;
  padding: 0px 0px;
  margin: 0px auto;
  width: 90%;
  display: block;
  resize: none;
  color: #444;
  font-size: 15px;
  line-height: 22px;
  font-family: inherit;
  color: #555;
  
  &:hover {
    cursor: default;
  }

  &:hover ${StyledRecipientsPopup} {
    display: block;
  }
`;

const RecipientRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Recipient = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
`;

const OldAddRecipient = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
`;

const DeleteRecipient = styled.div`
  padding: 3px 10px 0 0;
  cursor: pointer;
`;

const Add = styled.div`
  padding: 2px 10px; 0 0;
  cursor: pointer;
`;

const Recipients = ({ users, scheduled_report, onDelete }: { users: any, scheduled_report: any; onDelete?: any }) => {

  // Lookup recipient details from user list
  const recipient_details = scheduled_report.recipients.map((recipient) => {
    return users.filter((user) => user.id == recipient.id)[0] || {};
  });
  const dispatch = useDispatch()
  
  return (
    <StyledRecipients>
      {scheduled_report.recipients.map((recipient, index) => (
        <RecipientRow key={index}>
          <Recipient>{recipient.first_name} {recipient.last_name}</Recipient>
          <DeleteRecipient onClick={() => { dispatch(editReportSchedule({id: scheduled_report.id, recipients: recipient_details.filter(r => r.id !== recipient.id)})); dispatch(saveReportSchedule(scheduled_report.id)) }}><Icon width='15px' height='15px' icon={timesSolid} /></DeleteRecipient>
        </RecipientRow>
      ))}
    </StyledRecipients>
  )
}

const AddLogoText = styled.div<{ customer: any }>`
  position: absolute;
  top: ${props => props.customer.logo_uri === null ? '50%' : '130%'};
  left: 0;
  font-size: 12px;
  width: 100%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  display: ${props => props.customer.logo_uri === null || (typeof props.customer.logo !== 'undefined' && props.customer.logo !== null) ? 'block' : 'none'};
`;

const DisplayLogoText = css`
  &:hover ${AddLogoText} {
    display: block;
  }
`;

const AddLogo = styled.div<{ customer: any }>`
  border: ${props => props.customer.logo_uri === null ? '1px' : '0px'} dashed #AAAAAA;
  margin: 20px auto;
  height: 50px;
  font-size: 14px;
  color: #555;
  text-align: center;
  position: relative;
  width: 90%;
  cursor: pointer;
  
  ${props => props.customer.logo_uri === null? null : DisplayLogoText};
`;

const StyledPeriodSelect = styled.select`
  display: block;
  border: 0;
  height: 30px;
  margin: 5px;
  color: #333;
  width: 90%;
  padding-left: 10px;
  
  option {
    color: #555;
  }
`;

const PeriodSelect = ({ value, onChange }: { value: string; onChange: any; }) => {
  return (
    <StyledPeriodSelect value={value} onChange={onChange}>
      <option value='day'>Daily</option>
      <option value='week'>Weekly</option>
    </StyledPeriodSelect>
  )
}

const StyledTemplateSelect = styled.select`
  display: block;
  border: 0;
  height: 30px;
  margin: 5px;
  color: #333;
  width: 100%;
  padding-left: 10px;
  
  option {
    color: #555;
  }
`;

const TemplateSelect = ({ templates, value, onChange }: { templates: any; value: string; onChange: any; }) => {
  return (
    <StyledTemplateSelect value={value} onChange={onChange}>
    {templates.map((template, index) => (
      <option key={index} value={template.report_template_id}>{template.title}</option>
    ))}
    </StyledTemplateSelect>
  )
}

const RecipientsHeading = styled.div`
  display: flex;
  justify-content: space-between;
`;

const SavedStatus = styled.div<{saved: number}>`
  position: absolute;
  color: #333;
  top: 18px;
  right: 40px;
  text-align: center;
  font-size: 12px;
  color: #999;
  display: ${props => props.saved? 'none' : 'block'};
`;

const StyledAddRecipient = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const StyledAddRecipientSelect = styled.select`
  display: block;
  border: 0;
  height: 30px;
  width: 120px;
  margin: 5px;
  color: #333;
  
  option {
    color: #555;
  }
`;

const StyledAddRecipientButton = styled.button`
  display: block;
  color: '#1c94c4';
  width: '100px';
  background: '#f6f6f6';
  border: '1px solid #cccccc';
  
`;

const AddRecipient = ({ users, scheduled_report }: { users: any; scheduled_report: any; }) => {

  const recipients = scheduled_report.recipients.map(recipient => recipient.id)
  const dispatch = useDispatch();
  const [selectedUser, setSelectedUser] = useState(users.filter(user => !recipients.includes(parseInt(user.id)))[0].id)

  const editRecipients = () => {
    setSelectedUser(users.filter(user => !recipients.includes(parseInt(user.id)))[1].id)
    dispatch(editReportSchedule({id: scheduled_report.id, recipients: [users.filter(user => user.id === parseInt(selectedUser))[0], ...scheduled_report.recipients]}))
    dispatch(saveReportSchedule(scheduled_report.id))
  }
  
  return (
    <StyledAddRecipient>
      <StyledAddRecipientSelect value={selectedUser.toString()} name="recipients" id="recipients" onChange={(event) => {setSelectedUser(event.target.value)}}>
        {users.filter(user => !recipients.includes(parseInt(user.id))).map((user, index) => (
          <option key={index} value={user.id}>{user.first_name} {user.last_name}</option>
        ))}
      </StyledAddRecipientSelect>
      <Button onClick={editRecipients} color='#1c94c4' width='50px' background='#f6f6f6' border='1px solid #cccccc'>Add</Button>
    </StyledAddRecipient>
  )
}

const StyledMonthlyReportMessage = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: #777;
  margin: 20px 0;
  font-style: italic;
`;

export const MonthlyReportMessage = () => {
  return (
    <StyledMonthlyReportMessage>
      When scheduled, this report will be delivered by email, on the 1st of every month.
    </StyledMonthlyReportMessage>
  )
}

export const Settings = ({ templates, users, customer, scheduled_report, onCustomerChange }: { templates: any; users: any; customer: any; scheduled_report: any; onCustomerChange: any }) => {

  const dispatch = useDispatch()
  
  const hiddenFileInput = React.useRef(null);
  
  const handleLogoClick = (event) => {
    hiddenFileInput.current.click();
  }
  
  const getLogoText = (customer) => {
    if (typeof customer.logo !== 'undefined' && customer.logo !== null) {
      return customer.logo.name
    } else if (customer.logo_uri !== null) {
      return 'Click to Edit Logo'
    } else {
      return 'Click to Add Logo'
    }
  }
  
  const HandleCustomerNameInput = (text_event) => {
    dispatch(editCustomer({id: customer.id, name: text_event.target.value}))
    debouncedSaveCustomerToServer()
  }
  
  const HandleAddressInput = (text_event) => {
    dispatch(editCustomer({id: customer.id, address: text_event.target.value}))
    debouncedSaveCustomerToServer()
  }
  
  const HandlePeriodChange = (select_event) => {
    dispatch(editReportSchedule({id: scheduled_report.id, period: select_event.target.value}))
    dispatch(saveReportSchedule(scheduled_report.id))
  }
  
  const HandleTemplateChange = (select_event) => {
    console.log(select_event.target.value)
    dispatch(editReportSchedule({id: scheduled_report.id, template_id: select_event.target.value}))
    dispatch(saveReportSchedule(scheduled_report.id))
  }
  
  const saveCustomerToServer = () => {
    dispatch(saveCustomer(customer.id))
  }
  
  const debouncedSaveCustomerToServer = useCallback(debounce(saveCustomerToServer, 2000), [])
  
  const lookupTemplateName = (template_id) => {
    return templates.filter((template) => template.report_template_id == template_id)[0].title || 'Default';
  }
  
  const current_template = templates.filter((template) => template.report_template_id == scheduled_report.template_id)[0] || {};

  return (
    <SettingsContainer>
      <ListHeading>Settings</ListHeading>
      <SavedStatus saved={customer.saved}>Saving</SavedStatus>
      {current_template.requires_customer_details?
      <div><Row>
        <Label>Company Name</Label>
        <TextInput onChange={HandleCustomerNameInput} value={customer.name}/>
      </Row>
      <Row>
        <Label>Address</Label>
        <TextAreaInput onChange={HandleAddressInput} value={customer.address}/>
      </Row>
      <Row>
        <Label>Logo</Label>
        <AddLogo customer={customer} onClick={handleLogoClick}>
          {customer.logo_uri !== null? 
            <img height='50px' src={`https://${getHost()}/${customer.logo_uri}`}/>
          : null}
          <AddLogoText customer={customer}>{getLogoText(customer)}</AddLogoText>
          <input type='file' ref={hiddenFileInput} onChange={(event) => {dispatch(saveLogo(customer.id, event.target.files[0]))}} style={{display: 'none'}}/>
        </AddLogo>
      </Row></div>
      : <MonthlyReportMessage/>}
      {false &&<Row>
        <Label>
          Period
        </Label>
        <PeriodSelect value={scheduled_report.period} onChange={HandlePeriodChange}/>
      </Row>}
      <InlineRow>
        <Label margin='3px 0 10px 0'>
          Scheduled
        </Label>
        {typeof scheduled_report !== 'undefined'?
          <Toggle selected={scheduled_report.active == 1? true : false} onClick={() => {dispatch(toggleActive(scheduled_report.id))}} />
        : null}
      </InlineRow>
      <Row>
        <Label>
          Template
        </Label>
        <TemplateSelect templates={templates} value={scheduled_report.template_id} onChange={HandleTemplateChange}/>
      </Row>
      <Row margin='10px auto 0 auto'>
        <RecipientsHeading>
          <Label>Recipients</Label>
        </RecipientsHeading>
        <AddRecipient users={users} scheduled_report={scheduled_report}/>
        <Recipients users={users} scheduled_report={scheduled_report} onDelete={()=> {console.log('deleting recipient')}}/>
      </Row>
      {false?
        <Button onClick={() => { dispatch(saveCustomer(customer.id)) }} color='#1c94c4' width='100px' background='#f6f6f6' border='1px solid #cccccc'>Save</Button>
      : null}
    </SettingsContainer>
  )
}